import React from 'react';
import PropTypes from 'prop-types';
import { CardHeader, CardTitle, Button } from 'reactstrap';
import AppIcon from 'components/icons/AppIcon';

const PageCardHeader = ({ title, onBack }) => (
  <CardHeader className="page-card-header-wrap">
    <div className="page-card-header">
      <Button
        type="button"
        className="btn-icon btn-round page-card-header__back"
        onClick={onBack || (() => window.history.back())}
      >
        <AppIcon name="back" size="lg" />
      </Button>
      <CardTitle tag="h3" className="page-card-header__title">
        <strong>{title}</strong>
      </CardTitle>
    </div>
  </CardHeader>
);

PageCardHeader.propTypes = {
  title: PropTypes.node.isRequired,
  onBack: PropTypes.func,
};

export default PageCardHeader;
